@import (reference) '../../constants/spacing.module.less';

.body {
  padding: @space-16;
}

.footer-buttons {
  justify-content: flex-end;
}

.error-wrapper {
  padding-top: @space-12;
  padding-bottom: @space-12;
}

.password-challenge {
  width: 60%;
}

.password-form {
  position: relative;
}

.password-visibility-toggle {
  position: absolute;
  top: 45px;
  right: 6px;
  transform: translateY(-50%);
}

.mfa-enrollment-list {
  width: fit-content;
}

.mfa-enrollment {
  text-align: left;
}

.flex-center {
  align-items: center;
  justify-content: center;
}

.challenged-enrollment {
  justify-content: center;
  min-width: 35%;
  padding: @space-12 @space-16;

  border-radius: 24px;
  border: 1px solid var(--gray-DFE4E8);
  background: var(--gray-F9FAFB);
}

.code-section {
  align-items: center;
  justify-content: center;
  padding: @space-16 @space-0;
}

.challenge-input {
  height: 48px;
  width: 44px;
  font-size: 32px;
  text-align: center;
  font-weight: 500;
}

.challenge-button-content {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: @space-4;
}

.challenge-icon {
  height: 12px;
}

.resend-wrapper {
  justify-content: center;
  padding-top: @space-16;
  align-items: center;
}

.resend-content {
  font-size: 14px;
  margin: 0;
  padding-top: @space-8;
}

.loading {
  height: 48px;
  width: 48px;
  margin: 30px auto;
}
